module.exports = __webpack_public_path__ + "static/contact_image-06998cdba688451d5b389b40fed74010.jpg";